class SocialNetworkOperators {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/social-network-operators`;
    this.apiClient = apiClient;

  }

  async getOperatorsByStartupId() {

    return this.apiClient.get(this.basePath, {}, {});

  }

  async createOperator(operator) {

    return this.apiClient.post(this.basePath, {}, {}, operator);

  }

  async updateOperatorById(operatorId, operator) {

    const path = `${this.basePath}/:operatorId`;

    return this.apiClient.put(path, { operatorId }, {}, operator);

  }

  async deactivateOperatorById(operatorId) {

    const path = `${this.basePath}/:operatorId/deactivate`;

    return this.apiClient.put(path, { operatorId }, {}, {});

  }

}

export default SocialNetworkOperators;